import React, { Component } from 'react';
import qs from 'qs';
import Prismic from 'prismic-javascript';
import PrismicConfig from '../config/prismic';
 
const apiEndpoint = PrismicConfig.apiEndpoint
 
export default class Preview extends Component {
  
  componentWillMount() {
    this.preview(this.props);
  }
 
  preview(props) {
    const params = qs.parse(this.props.location.search.slice(1))
    console.log(props)
    Prismic.getApi(apiEndpoint)
      .then(api => { api.previewSession(params.token, PrismicConfig.linkResolver, '/')
      .then(url => {
        props.history.push(url); 
      });
    });
  }
 
  render() {
    return <div className="container"><h1>Loading previews...</h1></div>;
  }
}


// WEBPACK FOOTER //
// ./src/pages/Preview.js